import { styled, Typography } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';

const StyledFlexBox = styled(FlexBetween)(({ theme }) => ({
    flexWrap: 'wrap',
    marginBottom: 20,
    [theme.breakpoints.down(500)]: {
        width: '100%',
        '& .MuiInputBase-root': {
            maxWidth: '100%',
        },
        '& .MuiButton-root': {
            width: '100%',
            marginTop: 15,
        },
    },
}));

const ListHeader = ({ handleClick, buttonText = 'Add New Registration' }) => {
    return (
        <StyledFlexBox>
            <Typography sx={{ fontSize: 30, fontWeight: 650 }}>
                Registration Group Data
            </Typography>
        </StyledFlexBox>
    );
};

export default ListHeader;
